import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext.jsx';
import LandingPage from './pages/LandingPage.jsx';
import LoginPage from './pages/auth/LoginPage.jsx';
import RegisterPage from './pages/auth/RegisterPage.jsx';
import DashboardLayout from './layouts/DashboardLayout.jsx';
import SitesPage from './pages/dashboard/SitesPage.jsx';
import TemplatesPage from './pages/dashboard/TemplatesPage.jsx';
import SettingsPage from './pages/dashboard/SettingsPage.jsx';
import EditorPage from './pages/editor/EditorPage.jsx';
import EcommercePage from './pages/stubs/EcommercePage.jsx';
import MarketingPage from './pages/stubs/MarketingPage.jsx';
import IntegrationsPage from './pages/stubs/IntegrationsPage.jsx';
import HostingPage from './pages/stubs/HostingPage.jsx';
import SecurityPage from './pages/stubs/SecurityPage.jsx';
import CollaborationPage from './pages/stubs/CollaborationPage.jsx';
import MonetizationPage from './pages/stubs/MonetizationPage.jsx';
import DeveloperPage from './pages/stubs/DeveloperPage.jsx';
import CommunityPage from './pages/stubs/CommunityPage.jsx';

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="grid h-screen place-items-center text-ink-500">Loading…</div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/sites" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/login"
        element={
          <GuestOnly>
            <LoginPage />
          </GuestOnly>
        }
      />
      <Route
        path="/register"
        element={
          <GuestOnly>
            <RegisterPage />
          </GuestOnly>
        }
      />

      <Route
        element={
          <Protected>
            <DashboardLayout />
          </Protected>
        }
      >
        <Route path="/sites" element={<SitesPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/ecommerce" element={<EcommercePage />} />
        <Route path="/marketing" element={<MarketingPage />} />
        <Route path="/integrations" element={<IntegrationsPage />} />
        <Route path="/hosting" element={<HostingPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/collaboration" element={<CollaborationPage />} />
        <Route path="/monetization" element={<MonetizationPage />} />
        <Route path="/developer" element={<DeveloperPage />} />
        <Route path="/community" element={<CommunityPage />} />
      </Route>

      <Route
        path="/editor/:siteId/:pageId"
        element={
          <Protected>
            <EditorPage />
          </Protected>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
